















































import { Component, Prop, Vue } from 'vue-property-decorator';

import { downloadTextAsFile } from '../core/download';

const DEFAULT_VISIBLE_LIMIT = 200;

const FALLBACK_FILE_NAME = 'errors.txt';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.';

@Component
export default class MmErrorsPanel extends Vue {
	@Prop({ required: true }) readonly title!: string;

	@Prop({ default: '' }) readonly summary!: string;

	@Prop({ default: () => [] }) readonly lines!: string[];

	@Prop({ default: DEFAULT_VISIBLE_LIMIT }) readonly visibleLimit!: number;

	@Prop({ default: '' }) readonly downloadFileName!: string;

	@Prop({ default: true }) readonly closable!: boolean;

	get safeLines(): string[] {
		return Array.isArray(this.lines) ? this.lines : [];
	}

	get hasLines(): boolean {
		return this.safeLines.length > 0;
	}

	get effectiveLimit(): number {
		const raw = Number(this.visibleLimit);

		if (!isFinite(raw) || raw <= 0) {
			return DEFAULT_VISIBLE_LIMIT;
		}

		return Math.floor(raw);
	}

	get visibleLines(): string[] {
		return this.safeLines.slice(0, this.effectiveLimit);
	}

	get isTruncated(): boolean {
		return this.safeLines.length > this.effectiveLimit;
	}

	get summaryText(): string {
		return this.summary ? String(this.summary).trim() : '';
	}

	get shownOfText(): string {
		return this.$t(KEY_PREFIX + 'assignments.importErrShownOf', {
			shown: this.visibleLines.length,
			total: this.safeLines.length,
		}) as string;
	}

	get downloadText(): string {
		return this.$t(KEY_PREFIX + 'common.downloadTxt') as string;
	}

	get closeText(): string {
		return this.$t(KEY_PREFIX + 'common.close') as string;
	}

	get fileName(): string {
		const name = this.downloadFileName ? String(this.downloadFileName).trim() : '';

		return name !== '' ? name : FALLBACK_FILE_NAME;
	}

	handleDownload(): void {
		downloadTextAsFile(this.safeLines.join('\n'), this.fileName);
	}

	handleClose(): void {
		this.$emit('close');
	}
}
